// Traducciones del formulario de opinión del sorteo en español
const sorteoForm = {
    title: "📋 Formulario de Participación",
    duplicateError: "Ya has valorado el {{chapter}}. ¡Prueba con otro!",

    // Campos
    emailLabel: "📧 Correo universitario UEMC *",
    emailPlaceholder: "tu.nombre@alumnos.uemc.es",
    emailHelp: "Solo @alumnos.uemc.es",
    emailRequired: "Obligatorio",
    emailInvalid: "Solo se permiten correos @alumnos.uemc.es",

    chapterLabel: "📖 ¿Qué capítulo has leído? *",
    chapterError: "Selecciona un capítulo",
    chapter: "Capítulo",

    genderLabel: "¿Cuál es tu sexo?",
    genderMale: "Hombre",
    genderFemale: "Mujer",
    genderOther: "Otro",

    ageLabel: "¿Cuál es tu edad?",
    ageError: "Edad válida requerida",

    postalCodeLabel: "¿Cuál es tu código postal?",
    postalCodeError: "CP de 5 dígitos",

    formatLabel: "¿Cómo has leído el cómic?",
    formatDigital: "Digital",
    formatPrinted: "Impreso",

    readerLabel: "¿Te consideras lector/a habitual de cómics?",
    readerDescription: "1 = Nada habitual, 5 = Muy habitual",

    visitedLabel: "¿Has visitado el lugar del capítulo?",
    yes: "Sí",
    no: "No",

    knewPlaceLabel: "¿Conocías el lugar antes de leer el cómic?",

    visitInterestLabel: "¿Cuánto interés tienes en visitar el lugar?",
    visitInterestDescription: "1 = Ninguno, 5 = Mucho",

    emotionsLegend: "Emociones al leer el cómic",
    curiosityLabel: "Curiosidad (1 = Nada, 5 = Mucha)",
    prideLabel: "Orgullo por el patrimonio (1 = Nada, 5 = Mucho)",
    connectionLabel: "Conexión con el monumento (1 = Nada, 5 = Mucha)",

    readingTimeLabel: "¿Cómo valoras el tiempo de lectura?",
    short: "Corto",
    adequate: "Adecuado",
    long: "Largo",

    flashbacksLabel: "¿Entendiste los flashbacks del capítulo?",

    preferredFormatLabel: "¿Qué formato prefieres para leer cómics?",
    both: "Ambos",
    noAnswer: "NS/NC",

    adventuresLabel: "¿Te interesan las aventuras de Zaquiel?",
    adventuresDescription: "1 = Nada, 5 = Mucho",

    narrativeLabel: "¿Te ha gustado cómo se narra el monumento?",
    narrativeDescription: "1 = Nada, 5 = Mucho",

    commentsLabel: "Comentarios adicionales",

    gdprLabel: "He leído y acepto la Política de privacidad del sorteo",
    gdprError: "Debes aceptar la política de privacidad",

    required: "Campo obligatorio",
    submitButton: "Participar",
    submitting: "Enviando...",
    backButton: "Volver",
    submitError: "Error en el envío. Inténtalo de nuevo."
};

export default sorteoForm;
